export enum SubscriptionLevel {
  FREE = 'FREE',
  PRO = 'PRO',
  PRO_STANDARD = 'PRO_STANDARD',
  ENTERPRISE = 'ENTERPRISE',
  ENTERPRISE_STANDARD = 'ENTERPRISE_STANDARD',
  PREMIUM = 'PREMIUM',
  AUDIT = 'AUDIT',
  REG_MON = 'REG_MON',
  AUDIT_REG_MON = 'AUDIT_REG_MON'
}

export interface SubscriptionDetails {
  label: SubscriptionLevel;
  value?: number;
}

// TODO: @Loïc - this is overly complicated, we shouls stick with SubscriptionLevel and SubscriptionType,
// and in the "hasRightAccess", derives numbers from the levels.
export const Subscription: Record<SubscriptionLevel, SubscriptionDetails> = {
  [SubscriptionLevel.FREE]: { label: SubscriptionLevel.FREE, value: 1 },
  [SubscriptionLevel.PRO]: { label: SubscriptionLevel.PRO, value: 5 },
  [SubscriptionLevel.PRO_STANDARD]: {
    label: SubscriptionLevel.PRO_STANDARD,
    value: 5
  },
  [SubscriptionLevel.ENTERPRISE]: {
    label: SubscriptionLevel.ENTERPRISE,
    value: 10
  },
  [SubscriptionLevel.ENTERPRISE_STANDARD]: {
    label: SubscriptionLevel.ENTERPRISE_STANDARD,
    value: 10
  },
  [SubscriptionLevel.PREMIUM]: { label: SubscriptionLevel.PREMIUM, value: 20 },
  [SubscriptionLevel.AUDIT]: { label: SubscriptionLevel.AUDIT },
  [SubscriptionLevel.REG_MON]: { label: SubscriptionLevel.REG_MON },
  [SubscriptionLevel.AUDIT_REG_MON]: { label: SubscriptionLevel.AUDIT_REG_MON }
};

export enum SubscriptionType {
  COMPLIANCE = 'COMPLIANCE',
  DECLARATIVE = 'DECLARATIVE',
  ANY = 'ANY',
  CUSTOMS_BASE = 'CUSTOMS_BASE'
}

export const PRICING = {
  [SubscriptionType.COMPLIANCE]: {
    [Subscription.FREE.label]: {
      price: 0,
      includedUsers: 0,
      additionalUserPrice: 0,
      discounts: {
        oneYearSubscription: 0,
        oneYearUser: 0
      }
    },
    [Subscription.PRO_STANDARD.label]: {
      price: 199,
      includedUsers: 1,
      additionalUserPrice: 49,
      discounts: {
        oneYearSubscription: 240,
        oneYearUser: 55
      }
    },
    [Subscription.PRO.label]: {
      price: 199,
      includedUsers: 1,
      additionalUserPrice: 49,
      discounts: {
        oneYearSubscription: 200,
        oneYearUser: 50,
        extraYearSubscription: 360,
        extraYearUser: 60
      }
    },
    [Subscription.ENTERPRISE_STANDARD.label]: {
      price: 349,
      includedUsers: 5,
      additionalUserPrice: 39,
      discounts: {
        oneYearSubscription: 420,
        oneYearUser: 45
      }
    },
    [Subscription.ENTERPRISE.label]: {
      price: 349,
      includedUsers: 5,
      additionalUserPrice: 39,
      discounts: {
        oneYearSubscription: 350,
        oneYearUser: 40,
        extraYearSubscription: 600,
        extraYearUser: 60
      }
    },
    [Subscription.PREMIUM.label]: {
      price: 349,
      includedUsers: 5,
      additionalUserPrice: 39,
      discounts: {
        oneYearSubscription: 420,
        oneYearUser: 45
      }
    }
  },
  [SubscriptionType.DECLARATIVE]: {
    [Subscription.FREE.label]: {
      price: 0,
      pricePerExtraDeclaration: 0.99,
      freePerMonth: 10,
      discounts: {
        oneYearSubscription: 0
      }
    },
    [Subscription.PRO_STANDARD.label]: {
      price: 99,
      pricePerExtraDeclaration: 0.75,
      freePerMonth: 100,
      discounts: {
        oneYearSubscription: 120
      }
    },
    [Subscription.PRO.label]: {
      price: 99,
      pricePerExtraDeclaration: 0.75,
      freePerMonth: 100,
      discounts: {
        oneYearSubscription: 80,
        extraYearSubscription: 360
      }
    },
    [Subscription.ENTERPRISE_STANDARD.label]: {
      price: 299,
      pricePerExtraDeclaration: 0.65,
      freePerMonth: 400,
      discounts: {
        oneYearSubscription: 350
      }
    },
    [Subscription.ENTERPRISE.label]: {
      price: 299,
      pricePerExtraDeclaration: 0.65,
      freePerMonth: 400,
      discounts: {
        oneYearSubscription: 250,
        extraYearSubscription: 1080
      }
    },
    [Subscription.PREMIUM.label]: {
      price: 599,
      pricePerExtraDeclaration: 0.65,
      freePerMonth: 400,
      discounts: {
        oneYearSubscription: 500,
        extraYearSubscription: 2160
      }
    }
  }
};

